<template>
<!-- <div class="page" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中" > -->
<div class="page indexPage">
    <topNav></topNav>
    <AdvLamu :sendSc="true" :current_page="'1002'" :banner_name="'拉幕广告'" :banner_belong_area="'拉幕'" :advCode="'jylcw1079'" :isDD="true" :ddCode="'thrih1106'"></AdvLamu>
    <Header></Header>
    <columnNav></columnNav>
    <div class="pw">
        <AdvImage :sendSc="true" :current_page="'1002'" :banner_name="'通栏1'" :banner_belong_area="'通栏'" :advCode="'yzhnn1080'" :isDD="true" :ddCode="'wxdwi1107'"></AdvImage>
        <!-- <h3 class="columnTit mt10"><span>月度热门专场</span></h3>
        <div class="sessionList">
            <template v-for="(item,i) in specialsTopList">
                <router-link :to="{path:'/special_detail/'+item.special_code}" target="_blank" :key="i">
                    <div class="imgBox">
                        <el-image style="width: 100%; height: 100%;" :src="'https://thumb.artron.net/Img/image?c=1&h=64&w=180&src='+item.picture" fit="cover">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                            <div slot="error" class="el-image__error">
                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                            </div>
                        </el-image>
                    </div>
                </router-link>
            </template>
        </div> -->
        <div class="flex mt30">
            <div class="w780">
                <div class="bannerSwiper" id="bannerSwiper">
                    <el-carousel :interval="5000" height="348px">
                        <el-carousel-item v-for="(item,i) in swiperList" :key="i">
                            <a href="#" @click="jumpLink(item,i)">
                                <div class="imgBox">
                                    <el-image style="width: 100%; height: 100%;object-fit: cover" :src="'https://thumb.artron.net/Img/image?c=1&h=696&w=1560&src='+item.source_picture" fit="cover">
                                        <div slot="placeholder" class="image-slot">
                                            加载中<span class="dot">...</span>
                                        </div>
                                        <div slot="error" class="el-image__error">
                                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                        </div>
                                    </el-image>
                                    <div class="bannerText">
                                        <h3>{{item.title}}</h3>
                                    </div>
                                </div>
                            </a>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="aucNews mt30 flex">
                    <div class="newsLeft liveSwiper">
                        <AdvImage :advCode="'zlkyp1081'" :isDD="false" :ddCode="'ftjil1110'" :sendSc="true" :current_page="'1002'" :banner_name="'海报3（左侧海报）'" :banner_belong_area="'海报'" :isMartop="true"></AdvImage>
                    </div>
                    <div class="aucRight">
                        <template v-for="(item,i) in topNews">
                            <div class="newsTit" :key="i" v-if="i==0">
                                <h4><a :href="item.url" target="_blank">{{item.title}}</a></h4>
                                <p>{{ item.summary }}<a :href="item.url" target="_blank">详情</a></p>
                            </div>
                            <div class="listSlot" :key="i" v-if="i>0"><a :href="item.url" target="_blank">{{item.title}}</a></div>
                        </template>
                    </div>
                </div>
                <AdvImage :advCode="'otjsc1084'" :isDD="true" :ddCode="'acjhi1111'" :sendSc="true" :current_page="'1002'" :banner_name="'拍卖首页半通栏一（左侧）'" :banner_belong_area="'通栏'"></AdvImage>
                <IndexSession :onspecials="specialsList.onspecials" :soonspecials="specialsList.soonspecials" :result="specialsList.result" :isLogin="isLogin"></IndexSession>
                <AdvImage :advCode="'brtlp1085'" :isDD="true" :current_page="'1002'" :ddCode="'emcya1112'"></AdvImage>
                <IndexRank :isLogin="isLogin"></IndexRank>
                <AdvImage :advCode="'xvqrx1086'" :isDD="true" :current_page="'1002'" :ddCode="'hkrlw1113'"></AdvImage>
                <IndexNews></IndexNews>
            </div>
            <div class="w380">
                    <div class="adminLink">
                    
                    <div @click="goChangpai()">畅拍管理平台（仅拍行使用）</div>
                </div>
                <div class="adminLink">
                    <!-- <a href="/admin/adminiStrator/" target="_blank">拍卖官网管理</a> -->
                    <!-- <a href="javascript:;" @click="gotoLogin" v-if="!isLogin">在线拍商户中心</a>
                    <a href="https://auction-old.artron.net/help/introduce/html/introduce_brand.html" target="_blank" v-else-if="memType != 0">在线拍商户入驻</a>
                    <a href="https://jiaoyi.artron.net/" target="_blank" v-else>在线拍商户中心</a> -->
                    <!-- <a href="/sendInfor" target="_blank">我要送拍</a> -->
                    <!-- <a href="https://beian.artron.net/censorship.php" target="_blank">我要送鉴</a> -->
                    <div @click="dialogVisibleGotoApp=true">我要送拍（藏家使用）</div>
                </div>
               
                <div class="companyList " v-if="brandList.length">
                    <h3 class="columnTit"><span>热门拍卖公司</span></h3>
                    <div class="hotSwiper">
                        <ul class="fix">
                            <template v-for="(item,i) in brandList">
                                <li :key="i">
                                    <a href="#" @click="jumpLinkHotSwiper(item,i)" :title="item.title" target="_blank">
                                        <div class="imgBox">
                                            <el-image style="width: 100%; height: 100%;" :src="item.picture" fit="contain">
                                                <div slot="placeholder" class="image-slot">
                                                    加载中<span class="dot">...</span>
                                                </div>
                                                <div slot="error" class="el-image__error">
                                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                                </div>
                                            </el-image>
                                        </div>
                                    </a>
                                </li>
                            </template>
                        </ul>
                        <!-- <el-carousel indicator-position="outside" :autoplay="false" arrow="always">
                            <el-carousel-item v-for="(con,k) in Math.ceil(brandList.length/15)" :key="k">
                                <ul class="fix" v-if="k<2">
                                    <template v-for="(item,i) in brandList">
                                        <li :key="i" v-if="i>=(k*15) && i<(k+1)*15">
                                            <a href="#" @click="jumpLinkHotSwiper(item,i)" :title="item.title" target="_blank">
                                                <div class="imgBox">
                                                    <el-image style="width: 100%; height: 100%;" :src="item.picture" fit="contain">
                                                        <div slot="placeholder" class="image-slot">
                                                            加载中<span class="dot">...</span>
                                                        </div>
                                                        <div slot="error" class="el-image__error">
                                                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                                        </div>
                                                    </el-image>
                                                </div>
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                            </el-carousel-item>
                        </el-carousel> -->
                    </div>
                </div>
                <AdvImage :advCode="'tjzty1082'" :isDD="true" :ddCode="'epdrs1108'" :sendSc="true" :current_page="'1002'" :banner_name="'拍卖首页右侧海报1'" :banner_belong_area="'海报'"></AdvImage>
                <IndexDealRank :youhua="rankList.youhua" :dangdaiguohua="rankList.dangdaiguohua" :jinxiandaiguohua="rankList.jinxiandaiguohua" :gudaiguohua="rankList.gudaiguohua"></IndexDealRank>
                <IndexReport></IndexReport>
                <AdvImage :advCode="'jefju1083'" :isDD="true" :ddCode="'jqztt1109'" :current_page="'1002'"></AdvImage>
                <ClassData></ClassData>
            </div>
        </div>
        <!-- <IndexMedia :mediaList="mediaList"></IndexMedia> -->
        <div class="moreBox">
            <span @click="goZiXun">查看更多资讯</span>
        </div>
        <IndexCoop :coopList="coopList"></IndexCoop>
    </div>
    <anchorBox></anchorBox>
    <!-- <div id="anchor" style="">
        <div class="qrCode">
            <b title="二维码"></b>
            <div class="qr">
                <div id="code">
                    <ul>
                        <li><img alt="" src="@/assets/imgs/code_yun.png"></li>
                    </ul>
                </div>
            </div>
        </div>
        <div title="返回顶部" @click="toTop" class="ah" id="toTop" style="display: block;">返回顶部</div>
    </div> -->
    <el-dialog title="" :visible.sync="dialogVisible" custom-class="AdGroupBox" @close="adClose()">
        <AdvImage :advCode="'jrmrh1297'" :current_page="'1002'"></AdvImage>
    </el-dialog>
    <el-dialog title="" width="700px" :visible.sync="dialogVisibleGotoApp" custom-class="AdGroupBox">

        <img class="gotoImg" @click="jumpHrefLink('https://artexpress.artron.net/download/tulu')" src="@/assets/imgs/gotoApp2.png" alt="">
    </el-dialog>
    <copyright></copyright>
</div>
</template>

<script>
import copyright from "@/components/common/copyright";
import Header from "@/components/common/header";
import topNav from "@/components/common/topNav";
import anchorBox from "@/components/common/anchorBox";
import columnNav from "@/components/common/columnNav";
import ClassData from "@/components/index/ClassData";
import IndexNews from "@/components/index/IndexNews";
import IndexReport from "@/components/index/IndexReport";
import IndexRank from "@/components/index/IndexRank";
import IndexSession from "@/components/index/IndexSession";
import IndexDealRank from "@/components/index/IndexDealRank";
import IndexMedia from "@/components/index/IndexMedia";
import IndexCoop from "@/components/index/IndexCoop";
import AdvLamu from '@/components/advert/advLamu';
import AdvImage from '@/components/advert/advImage';
import $ from 'jquery'
import {
    sendScData
} from "@/utils/buriedPoint";
import Cookies from 'js-cookie'
import {
    getOther,
    getSessionNew,
    indexGatherList,
    getSession
} from "@/api/index";
import {
    mapActions,
    mapGetters
} from 'vuex';
import {
    getMemType
} from "@/api/index";
import {
    getMemToken
} from "@/api/auction";

export default {
    name: "index",
    data() {
        return {
            divTop: '',
            memToken: '',
            dialogVisible: false,
            dialogVisibleGotoApp: false,
            bannerSwiperFlag: true,
            specialsList: {
                respecial: [],
                onspecials: [],
                soonspecials: [],
                result: []
            },
            isLogin: 0,
            mediaList: [],
            brandList: [],
            rankList: {
                dangdaiguohua: [],
                gudaiguohua: [],
                jinxiandaiguohua: [],
                youhua: []
            },
            coopList: [],
            specialsTopList: [],
            swiperList: [],
            topNews: [],
            isLoading: true,
            classAdvArr: [],
            brandAdvArr: [],
            otherAdvArr: [],
            memType: 0
        }
    },
    mounted() {
        this.getOther();
        this.getSession();
        this.getMemType();
        if (!this.getIsLoadIng) {
            this.getPageHome([0, () => {
                this.filteData();
            }])
        } else {
            this.filteData();
        }
        window.scroll({
            top: 0,
            left: 0
        })
        this.renderAD('jrmrh1297')
        if (this.getCookie("_at_pt_0_")) {
            this.isLogin = 1
        }

        this.divTop = document.getElementById('bannerSwiper').offsetTop;
        window.onscroll = this.showDiv();
        // const observer = new IntersectionObserver(entries => {
        //     entries.forEach(entry => {
        //         if (entry.isIntersecting) {
        //             // 元素进入视口
        //             alert(1)
        //         } else {
        //             alert(2)
        //             // 元素离开视口
        //         }
        //     });
        // });

        // observer.observe(this.$refs.targetElement);

    },
    asyncData({
        store
    }) {
        return store.dispatch("pageHome/getPageHome", [0, null, () => {}]);
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageHome/getIsLoadIng",
            getData: "pageHome/getData",
        }),
    },
    methods: {
        ...mapActions({
            getPageHome: "pageHome/getPageHome"
        }),
        swipeScFun(index) {
            sendScData('bannerExpose', {
                banner_type_id: this.swiperList[index].type,
                banner_advertiser_id: this.swiperList[index].id,
                banner_link: this.swiperList[index].link,
                // banner_englishName: this.swiperList[index].englishName,
            })
        },
        adClose() {
            const now = new Date();
            const timestamp = now.getTime();
            Cookies.set('adTime3', timestamp);
        },
        renderAD(el) {
            let that = this
            fetch('https://show.artron.net/g?english=' + el).then(r => r.text()).then(res => {

                let adTime = Cookies.get('adTime3')
                const now = new Date();
                const timestamp = now.getTime();
                if (((Number(adTime) + 10800000) < timestamp || !adTime) && res) {
                    // console.log('console.log(res)')
                    that.dialogVisible = true;
                }
            })
        },

        showDiv() {
            //获取滚动条距离页面顶部的距离，如果滚动条距离页面距离大于目标元素距离页面顶部的距离，则目标元素已经往上滚动，且超出了当前可视区域，则给该元素添加fixed属性
            var scroolTop = document.documentElement.scrollTop;
            if (!(scroolTop >= this.divTop)) {
                if (this.bannerSwiperFlag) {
                    sendScData('bannerScan', {
                        banner_belong_area: "PC端拍卖首页",
                        banner_name: "轮播图",
                        banner_id: '',
                    });
                    this.bannerSwiperFlag = false
                    window.removeEventListener('scroll', this.showDiv(), false);
                }

            }
        },
        jumpLinkHotSwiper(item, i) {
            // sendScData('bannerClick', {
            //     current_page: 'PC端拍卖首页' ,
            //     banner_belong_area: '拍卖公司品牌专区',
            //     banner_name: '综合'+ (Number(i) + 1),
            //     banner_id: item.title+item.organ_code,
            // });
            if (item.link) {
                window.location.href = item.link
            }

        },
        jumpHrefLink(e) {
            window.location.href = e
        },
        jumpLink(item, i) {
            sendScData('bannerClick', {
                current_page: 'PC端拍卖首页',
                banner_belong_area: '轮播图',
                banner_name: '轮播图' + (Number(i) + 1),
                banner_id: item.id,
            });
            if (item.pcurl && item.pcurl != 0) {
                window.open(item.pcurl, '_blank')
            }

        },
        goZiXun() {
            window.location.href = "https://auction.artron.net/morenews/16"
        },
        toTop() {
            $("html, body").animate({
                    scrollTop: 0
                },
                300);
        },
        filteData() {
            console.log(this.$store.state["pageHome"]["data"])
            this.specialsTopList = this.$store.state["pageHome"]["data"].specials;
            this.swiperList = this.$store.state["pageHome"]["data"].slicepics;
            this.topNews = this.$store.state["pageHome"]["data"].news;
            let meta = this.$store.state["pageHome"]["data"].meta;
            let head = document.getElementsByTagName('head');
            document.title = meta.title
            if (!document.querySelector('meta[name=description]')) {
                let meta2 = document.createElement('meta');
                meta2.name = 'description';
                meta2.content = meta.description || '';
                head[0].appendChild(meta2)
            } else {
                document.querySelector('meta[name=description]').setAttribute('content', meta.description || '')
            }
        },
        goChangpai(){
            if(this.memToken){
                window.location.href = 'https://changpai.artron.net/authentication?account_token='+this.memToken
            }else{
                window.location.href = 'https://passport.artron.net/login?appId=105&redirect=https://changpai.artron.net'
            }
           
        },
        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.memType = res.data.zxp_store_open
                }
            })
            getMemToken().then((res) => {
                if (res.code == 0) {
                    this.memToken = res.data.token
                }
            })
        },
        getOther() {
            getOther().then((res) => {
                let data = res.data;
                this.mediaList = data.media;
                this.brandList = data.pinpai;
                this.rankList.dangdaiguohua = data.rank.dangdaiguohua
                this.rankList.gudaiguohua = data.rank.gudaiguohua
                this.rankList.jinxiandaiguohua = data.rank.jinxiandaiguohua
                this.rankList.youhua = data.rank.youhua
                this.mediaList = this.group(this.mediaList, 6)
                this.coopList = data.coop
                this.isLoading = false;
            });
        },
        group(arr, length) {
            let index = 0;
            let newArray = [];
            while (index < arr.length) {
                newArray.push(arr.slice(index, index += length));
            }
            return newArray;
        },
        getSession() {
            getSessionNew().then((res) => {
                // this.specialsList.onspecials = res.data.onspecials;
                // this.specialsList.soonspecials = res.data.soonspecials;
                this.specialsList.result = res.data.result;
              

            });
            indexGatherList().then((res) => {
                if (res.code == 0) {
                    this.specialsList.onspecials = res.data.today_auction_specials || [];
                    if (this.specialsList.onspecials.length > 8) this.specialsList.onspecials.splice(8);
                    this.specialsList.soonspecials = res.data.soonspecials || [];
                    if (this.specialsList.soonspecials.length > 2) this.specialsList.soonspecials.splice(2);
                }
            });
            // getSession().then((res) => {
            //     this.specialsList.result = res.data.result;
            // });
        },
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            } else {
                return null;
            }
        },
        gotoLogin() {
            window.location.href = 'https://passport.artron.net/login?appId=1&redirect=' + location.href
        }
    },
    components: {
        copyright,
        Header,
        topNav,
        columnNav,
        ClassData,
        IndexNews,
        IndexReport,
        IndexRank,
        IndexSession,
        IndexDealRank,
        anchorBox,
        // IndexMedia,
        IndexCoop,
        AdvLamu,
        AdvImage,
    }
}
</script>

<style lang="scss">
.AdGroupBox {
    background: rgba(0, 0, 0, 0);
    box-shadow: unset;
    width: fit-content;

    .mt20 {
        border-radius: 15px;
        overflow: hidden;
    }

    .el-dialog__body {
        padding: 0;

        .gotoImg {
            width: 100%;
            cursor: pointer;
        }
    }

    .el-dialog__header {
        position: absolute;
        color: #fff;
        padding: 0;
        right: -50px;
        top: -50px;

        .el-dialog__headerbtn .el-dialog__close {
            color: #fff;
            background: rgba(0, 0, 0, 0.3);
            padding: 6px;
            border-radius: 20px;
            border: 1px solid rgba(255, 255, 255, 0.5);
        }
    }
}
</style>
<style lang="scss" scoped>
@import url("../assets/css/reset.css");

.moreBox {
    width: 100%;
    text-align: center;
    font-weight: 600;
    margin-top: 70px;
    margin-bottom: 70px;

    span {
        display: block;
        cursor: pointer;
        margin: 0 auto;
        width: 100px;
        margin-left: 325px;
        color: #262626;
    }
}

/*月度热门专场*/
.sessionList {
    display: flex;
    justify-content: space-between;

    a {
        width: 180px;
        height: 64px;
        position: relative;
        border-radius: 4px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}

/*轮播图*/
.bannerSwiper {
    border-radius: 4px;
    overflow: hidden;

    .imgBox {
        position: relative;
    }

    .bannerText {
        height: 66px;
        background-color: rgba(0, 0, 0, .45);
        line-height: 66px;
        color: #fff;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;

        h3 {
            width: 650px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 18px;
            margin-left: 20px;
            font-weight: bold;
        }
    }

    /deep/.el-carousel__indicators--horizontal {
        left: inherit;
        right: 16px;
        bottom: 17px;
        transform: translateX(0);
    }

    /deep/.el-carousel__button {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        opacity: 1;
    }

    /deep/.el-carousel__indicator.is-active button {
        background-color: #329d15;
    }
}

/*焦点新闻*/
.newsLeft {
    width: 398px;
    height: 224px;
    position: relative;

    .hoverTxt {
        display: block;
        background-color: rgba(0, 0, 0, .45);
        height: 40px;
        width: 358px;
        padding: 0 20px;
        color: #fff;
        line-height: 40px;
        left: 0;
        bottom: 0;
        font-size: 16px;
        position: absolute;
    }

    .liveFlag {
        position: absolute;
        display: flex;
        align-items: center;
        background-color: #329d15;
        padding: 0 8px;
        height: 20px;
        border-radius: 4px;
        left: 10px;
        top: 10px;
        color: #fff;
        font-size: 12px;
    }

    .liveBtn {
        position: center;
        display: block;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, .65);
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -18px 0 0 -18px;
        background-image: url("../assets/imgs/icon_play.png");
        background-repeat: no-repeat;
        background-position: center;
    }
}

.liveSwiper {
    /deep/.el-carousel__indicators--horizontal {
        display: none;
    }
}

.aucRight {
    width: 362px;

    .newsTit {
        h4 {
            line-height: 32px;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 10px;
        }

        p {
            font-size: 14px;
            line-height: 22px;
            color: #8C8C8C;
            display: -webkit-box;
            max-height: 44px;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;

            a {
                margin-left: 10px;
            }
        }

        margin-bottom: 20px;
    }

    .listSlot {
        line-height: 22px;
        font-size: 14px;
        color: #595959;
        margin-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-left: 14px;
        position: relative;

        a {
            color: #595959;
        }

        a:hover {
            color: #329D15;
        }
    }

    .listSlot:before {
        display: block;
        content: '';
        width: 4px;
        height: 4px;
        background-color: #329D15;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -2px;
        border-radius: 50%;
    }

    .listSlot:last-child {
        margin-bottom: 0;
    }
}

/*管理链接*/
.adminLink {
    div {
        display: inline-block;
        width: 100%;
        height: 40px;
        border: 1px solid #329D15;
        color: #6FBA5B;
        margin-right: 10px;
        margin-bottom: 10px;
        text-align: center;
        background-color: #EAF5E7;
        line-height: 40px;
        transition: .2s all ease-in-out;
        cursor: pointer;
        border-radius: 4px;
    }

    div:nth-child(2n) {
        margin-right: 0;
    }

    div:hover {
        color: #329D15;
        border-color: #ADD8A1;
    }

    a {
        display: inline-block;
        width: 180px;
        height: 40px;
        border: 1px solid #329D15;
        color: #6FBA5B;
        margin-right: 10px;
        margin-bottom: 10px;
        text-align: center;
        background-color: #EAF5E7;
        line-height: 40px;
        transition: .2s all ease-in-out;
        border-radius: 4px;
    }

    a:nth-child(2n) {
        margin-right: 0;
    }

    a:hover {
        color: #329D15;
        border-color: #ADD8A1;
    }
}

/*拍卖机构*/
.companyList {
    li {
        width: 120px;
        height: 68px;
        margin: 0 10px 10px 0;
        float: left;
        border-radius: 4px;
        overflow: hidden;
    }

    li:nth-child(3n) {
        margin-right: 0;
    }
}

.adv224 {
    height: 224px;
    overflow: hidden;
}

.hotSwiper {
    position: relative;

    /deep/ .el-carousel--horizontal {
        padding-top: 50px;
        margin-top: -50px;
    }

    /deep/.el-carousel__indicators--outside {
        position: absolute;
        top: 3px;
        right: 74px;
        left: inherit;

        .el-carousel__indicator--horizontal {
            padding: 0;
            margin-left: 10px;

            .el-carousel__button {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #F2F2F2;
                opacity: 1;
            }
        }

        .el-carousel__indicator.is-active button {
            background-color: #329D15;
        }
    }

    /deep/.el-carousel__arrow {
        width: 20px;
        height: 20px;
        background-color: #329d15;
        top: -46px;
        transform: translateY(0);
        display: block !important;
    }

    /deep/.el-carousel__arrow:hover {
        background-color: #5BB144;
    }

    /deep/.el-carousel__arrow--left {
        left: inherit;
        right: 34px;
    }

    /deep/.el-carousel__arrow--right {
        right: 0;
    }
}
</style>
